<kendo-window>
  <kendo-window-titlebar class="small-padding">
    <div class="k-window-title">{{title}}</div>
  </kendo-window-titlebar>
  <div class="align-center msg-content">
    <p class="small-margin">
      {{msgText}}
    </p>
    <button kendoButton type="button" [primary]="true" (click)="onClick()">Ok</button>
  </div>
</kendo-window>